import "./Loading.css";

function Loading(props) {
    return (
        <div className="LoadingComponent">
            <div className="LoadingContainer">
                <div className="loadingIcon">
                <i className="ri-loader-2-fill"></i>
                </div>
                <div className="text">در حال بارگذاری لطفا منتظر بمانید...</div>
            </div>
        </div>
    );
}

export default Loading;
